import { AxiosError, HttpStatusCode } from "axios";

export class DomainError {
  code: string;
  status: HttpStatusCode;
  data: string[];

  constructor(error: any) {
    if (error instanceof AxiosError) {
      this.status = error.response?.status || 500;
      this.code = error.response?.data?.code || "INTERNAL_SERVER_ERROR";
      this.data = error.response?.data ?? [];
    } else if (error instanceof DomainError) {
      this.code = error.code;
      this.status = error.status;
      this.data = error.data;
    } else {
      this.code = "INTERNAL_SERVER_ERROR";
      this.status = HttpStatusCode.InternalServerError;
      this.data = [];
    }
  }
}
